import FileVM from './file-vm';
export default {
  init: function() {
    console.log('Initializing Kadenze.GradebookFileView');

    var params = $('#coursework_field_entries_json').val(),
      el = $('#gradebook_file_view')[0];

    ko.applyBindings(new FileVM(params), el);
  }
};

